import { isPrivate } from '@wix/communities-forum-client-commons/dist/src/services/category-privacy-utils';

export const isFollowButtonVisible = (category, canSubscribe) => {
  return !isPrivate(category) || canSubscribe;
};
